import React, { useState } from 'react';

const ShareButton = ({ content, title = "DataWeb AI Report", text = "Check out this AI-generated report" }) => {
  const [showFallback, setShowFallback] = useState(false);

  const handleShare = async () => {
    // Check if Web Share API is supported
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          // For text content, we'll share as text
          // You could also create a URL to share instead
          text: `${text}\n\n${content.substring(0, 500)}...`
        });
      } catch (err) {
        // User cancelled or error occurred
        if (err.name !== 'AbortError') {
          console.error('Error sharing:', err);
          setShowFallback(true);
        }
      }
    } else {
      // Fallback for desktop - show modal with copy link
      setShowFallback(true);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(content);
    alert('Report copied to clipboard!');
    setShowFallback(false);
  };

  return (
    <>
      <button
        onClick={handleShare}
        className="flex items-center space-x-2 p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
        title="Share report"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
        <span className="hidden sm:inline text-sm">Share</span>
      </button>

      {/* Fallback Modal for Desktop */}
      {showFallback && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setShowFallback(false)}>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Share Report</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              Copy the report to share it with others
            </p>
            <div className="flex space-x-3">
              <button
                onClick={copyToClipboard}
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
              >
                Copy to Clipboard
              </button>
              <button
                onClick={() => setShowFallback(false)}
                className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShareButton;